// extracted by mini-css-extract-plugin
export default {"side-panel":"SidePanel_side-panel__A933H","open":"SidePanel_open__irwm3","close":"SidePanel_close__JS+QI","danger-zone":"SidePanel_danger-zone__DBUci"};